import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

interface ModalProps {
  title: string;
  isVisible: boolean;
  onPressConfirm: () => void;
  onPressCancel: () => void;
}

const CustomWarningModal: React.FC<ModalProps> = ({
  title,
  isVisible,
  onPressConfirm,
  onPressCancel,
}) => {
  return (
    <Dialog
      open={isVisible}
      onClose={onPressCancel}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      PaperProps={{ style: { padding: "20px", borderRadius: 10 } }}
    >
      <DialogContent>
        <WarningIcon
          color="primary"
          style={{
            fontSize: 70,
            display: "block",
            margin: "0 auto",
            marginBottom: 20,
          }}
        />
        <Typography
          variant="body1"
          id="modal-title"
          style={{ textAlign: "center", marginBottom: 20 }}
        >
          {title}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          <Button onClick={onPressConfirm} color="primary" variant="contained">
            Si
          </Button>
        </Box>
        <Box display="flex" justifyContent="center" width="100%">
          <Button onClick={onPressCancel} color="primary" variant="contained">
            No
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CustomWarningModal;
